import { observer } from "mobx-react-lite";
import ToggleSwitch from "../../../components/ui/ToggleSwitch";
import CustomInput from "../../../components/ui/CustomInput";
import categoryPageStore from "../store/categoryPageStore";
import Button from "../../../components/ui/Button";
import { isMobile } from "react-device-detect";
import Modal from "../../../components/ui/Modal";
import { useState } from "react";
import { Select } from "../../../components/ui/Select";
import { Settings2Icon } from "lucide-react";

const CategoryListPageFilters = ({ refKey }: { refKey: string }) => {

  const handleApply = async () => {
    await categoryPageStore.getProductsByCategory(
      refKey,
      categoryPageStore.products?.current_page,
    );
    if(isMobile) { setIsOpenFilters(false); }
  };

  const handleReset = async () => {
    categoryPageStore.resetFilters();
    await categoryPageStore.getProductsByCategory(refKey);
    if(isMobile) { setIsOpenFilters(false); }
  };

  const renderFilters = () => {
    return (
      <div className="flex flex-col gap-[25px]">
        <div className="flex flex-col gap-[15px]">
          <h2 className="font-semibold text-[20px] text-[#232323]">Цена</h2>
          <div className="flex items-center gap-[15px] h-[30px]">
            <div className="flex items-center gap-[6px]">
            <span className="text-[#474A51] font-semibold text-[15px] tracking-[-2%]">От</span>
             <CustomInput
              type="number"
              placeholder="50"
              value={categoryPageStore.priceFrom}
              onChange={(e) => categoryPageStore.setPriceFrom(e.target.value)}
              disabled={categoryPageStore.isLoading}
              min={0}
              className="!h-[30px] !rounded-[8px] !w-[100px] !pl-[5px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            />
            </div>
            <div className="flex items-center gap-[6px]">
              <span className="text-[#474A51] font-semibold text-[15px] tracking-[-2%]">До</span>
          <CustomInput
              type="number"
              placeholder="420"
              value={categoryPageStore.priceTo}
              onChange={(e) => categoryPageStore.setPriceTo(e.target.value)}
              disabled={categoryPageStore.isLoading}
              min={0}
              className="h-[30px] !rounded-[8px] !w-[100px] !pl-[5px] [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[15px]">
          <h2 className="font-semibold text-[20px] text-[#232323]">
            Производитель
          </h2>
          <Select
            options={categoryPageStore.brandsOption}
            value={categoryPageStore.brand}
            onChange={(val) => categoryPageStore.setBrand(String(val))}
            placeholder="Выберите производителя"
            searchPlaceholder="Все производители"
            disabled={categoryPageStore.isLoading}
            className="w-full !cursor-pointer"
            searchable
          />
        </div>

              {/* <div className="flex flex-col gap-[15px]">
          <h2 className="font-semibold text-[20px] text-[#232323]">
            Дополнительно
          </h2>
          <ToggleSwitch
            id="original-part"
            label="Оригинальная запчасть"
            checked={categoryPageStore.isOriginal}
            onChange={() => categoryPageStore.toggleIsOriginal()}
            disabled={categoryPageStore.isLoading}
          />
        </div> */}

        <div className="flex gap-[10px] pt-[5px]">
          <Button
            style="primary"
            onClick={handleApply}
            disabled={categoryPageStore.isLoading}
            fullWidth
            className="!bg-[#232323] !rounded-[12px] !h-[43px] hover:!opacity-75"
          >
            Применить
          </Button>
          <Button
            style="outline"
            onClick={handleReset}
            disabled={categoryPageStore.isLoading}
            fullWidth
            className="!bg-[white] !rounded-[12px] !h-[43px] !hover:opacity-75 !text-center !flex !items-center !justify-center !text-[#232323] !border-[#232323] !border-[1px] hover:!bg-[#232323] hover:!text-[white]"
          >
            Сбросить
          </Button>
        </div>
      </div>
    );
  };

  const [isOpenFilters, setIsOpenFilters] = useState(false);

  if (!isMobile) {
    return (
      <div className="bg-white rounded-[20px] w-1/2 max-w-[350px] min-w-[350px] p-[20px] max-h-max flex flex-col shadow-[0_2px_20px_#0000001a]">
        {renderFilters()}
      </div>
    );
  } else {
    return (
      <div id="filters" className="flex flex-row w-full px-2 gap-2">
       <Button
          disabled={categoryPageStore.isLoading}
          onClick={() => setIsOpenFilters(!isOpenFilters)}
          className="!self-start !h-[33px] flex gap-[7px] flex-row items-center ring-[1px] ring-[#54545657] !text-center !px-[10px] !py-[7px] ! !rounded-[12px] !border-[#232323] !text-[#232323] !bg-white hover:!bg-[#232323] hover:!text-white"
        >
         <Settings2Icon className="!text-[#232323]" size={13}></Settings2Icon>
          <span className="text-[#333333] text-[13px]">Фильтры</span>
        </Button>
        {(() => {
          const sortOptions = [
            { value: undefined, label: "Сортировка" },
            { value: "price:asc", label: "По возрастанию цены" },
            { value: "price:desc", label: "По убыванию цены" },
            { value: "name:asc", label: "По наименованию A-Z/А-Я" },
            { value: "name:desc", label: "По наименованию Z-A/Я-А" },
          ];
          const sortValue =
            categoryPageStore.sortBy && categoryPageStore.sortDirection
              ? `${categoryPageStore.sortBy}:${categoryPageStore.sortDirection}`
              : "";
          return (
            <Select
              options={sortOptions}
              value={sortValue}
              onChange={(val) => {
                const [by, dir] = String(val).split(":");
                categoryPageStore.setSort(
                  by as "name" | "price" | "",
                  dir as "asc" | "desc" | ""
                );
                categoryPageStore.getProductsByCategory(refKey, categoryPageStore.products?.current_page);
              }}
              placeholder="Сортировка"
              disabled={categoryPageStore.isLoading}
              className="w-full !h-[33px] text-[13px]"
            />
          );
        })()}
        <Modal title="Фильтры" className="p-[15px]" isOpen={isOpenFilters} onClose={() => setIsOpenFilters(false)}>
          <div className="" title="Фильтры">{renderFilters()}</div>
        </Modal>
      </div>
    );
  }
};

export default observer(CategoryListPageFilters);
